import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'lazysizes'

import '../../src/util/install_sentry'
import 'Components/refosumu/call_to_action/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/site_header/component'
import 'Components/refosumu/site_header_navigation/component'
import 'Components/refosumu/site_footer/component'
import 'Components/refosumu/floating/component'
import 'Components/refosumu/basics/breadcrumb/component'

// セレクタ定義
const ROOT_TARGET_CLASS_NAME = 'js-toggleOpenClass-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const ITEM_TARGET_CLASS_NAME = 'js-toggleOpenClass-item-target'
const ITEM_TARGET_SELECTOR = `.${ITEM_TARGET_CLASS_NAME}`

const OPEN_TRIGGER_CLASS_NAME = 'js-toggleOpenClass-open-trigger'
const OPEN_TRIGGER_SELECTOR = `.${OPEN_TRIGGER_CLASS_NAME}`

// 開いた状態のクラス定義
const OPEN_CLASS_NAME = 'is-open'

const toggleOpenClass = () => {
  const rootElements = document.querySelectorAll(ROOT_TARGET_SELECTOR)

  // 要素がない場合はここで終了
  if (rootElements.length) {
    rootElements.forEach((rootElement) => {
      const accordionItems = rootElement.querySelectorAll(ITEM_TARGET_SELECTOR)

      // さらに要素がない場合はここで終了
      if (accordionItems.length) {
        accordionItems.forEach((accordionItems) => {
          const accordionTrigger = accordionItems.querySelector(OPEN_TRIGGER_SELECTOR)

          accordionTrigger.addEventListener('click', () => {
            accordionItems.classList.toggle(OPEN_CLASS_NAME)
          })
        })
      }
    })
  }
}

window.addEventListener('load', () => {
  toggleOpenClass()
})
